// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'location-solid';

export const Component = () => (
  <path d='M18.223 2.442C16.595.814 14.631 0 12.333 0c-2.299 0-4.263.814-5.89 2.442C4.813 4.07 4 6.034 4 8.332c0 2.156.814 4.79 2.395 7.903 1.58 3.113 3.208 5.652 4.789 7.711.287.383.67.575 1.149.575s.862-.191 1.149-.575c1.58-2.06 3.209-4.645 4.79-7.759 1.58-3.064 2.394-5.699 2.394-7.854 0-2.3-.814-4.263-2.443-5.89ZM14.775 9.77c-.67.67-1.484 1.006-2.442 1.006-.958 0-1.772-.335-2.442-1.006-.67-.67-1.006-1.484-1.006-2.394 0-.958.335-1.772 1.006-2.442.67-.67 1.484-1.006 2.442-1.006.958 0 1.772.335 2.442 1.006.67.67 1.005 1.484 1.005 2.442 0 .91-.335 1.724-1.005 2.394Z' />
);

export const viewBox = '0 0 25 25';
